// MSAL imports
import {
  PublicClientApplication,
  EventType,
  EventMessage,
  AuthenticationResult,
  SilentRequest,
  AccountInfo,
} from '@azure/msal-browser'
import { msalConfig } from './config'
import { Capacitor } from '@capacitor/core'
import {
  NavigationAuthenticationClient,
  instantiateNativeClient,
} from '../../native/utils/NavigationClient'

export const msalInstance = new PublicClientApplication(msalConfig)
export const nativeNavigationClient = new NavigationAuthenticationClient(msalInstance)
export const createLoginTokenRequest = (prompt = 'login', account?: AccountInfo) => {
  const accessTokenRequest: SilentRequest = {
    scopes: [`${process.env.REACT_APP_REQUEST_API_SCOPES}`],
    account: account,
    prompt: prompt,
  }

  return accessTokenRequest
}

if (Capacitor.isNativePlatform()) {
  instantiateNativeClient(nativeNavigationClient)
  msalInstance.setNavigationClient(nativeNavigationClient)
}

// High level event callbacks
msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult
    const account = payload.account
    msalInstance.setActiveAccount(account)
  }

  if (!Capacitor.isNativePlatform()) {
    if (
      event.eventType === EventType.LOGIN_FAILURE &&
      event.error?.message.includes('AADB2C90118')
    ) {
      sessionStorage.clear()
      msalInstance.loginRedirect({
        scopes: [],
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        authority: process.env.REACT_APP_AZURE_B2C_AUTHORITY_PASSWORD_RESET!,
      })
    }
  }
})

// msalInstance
//   .handleRedirectPromise()
//   .then(() => {
//     // Check if user signed in
//     const account = msalInstance.getActiveAccount()
//     if (!account) {
//       // redirect anonymous user to login page
//       msalInstance.loginRedirect()
//     }
//   })
//   .catch((err) => {
//     console.log(err)
//   })

export default msalInstance
